import { useTranslation } from "react-i18next";

interface TextProps {
  text: string;
  className?: string;
  translate?: boolean;
  size?: number;
}

const Text: React.FC<TextProps> = ({
  text,
  className,
  translate = true,
  size = 15,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`text-default${className ? ` ${className}` : ""}`}
      style={{ fontSize: `${size}px` }}
    >
      {translate ? t(text) : text}
    </div>
  );
};

export default Text;
